import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GmDashboardRoutingModule } from './gm-dashboard-routing.module';

import { GmdashboardComponent } from './gmdashboard/gmdashboard.component';
import { AddemployeeComponent } from './addemployee/addemployee.component';
import { AddcameradialogComponent } from './addcameradialog/addcameradialog.component';
import { AddvideoComponent } from './addvideo/addvideo.component';
import { GmdashboardLandingComponent } from './gmdashboard-landing/gmdashboard-landing.component';
import { GmdashboardLinkComponent } from './gmdashboard-link/gmdashboard-link.component';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { VideoComponent } from './video/video.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatOptionModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { NgxSpinnerModule } from 'ngx-spinner';

 


@NgModule({
  declarations: [
    GmdashboardComponent,
    AddemployeeComponent,
    AddcameradialogComponent,
    AddvideoComponent,
    GmdashboardLandingComponent,
    GmdashboardLinkComponent,
    VideoComponent
  ],
  imports: [
    CommonModule,
    DragDropModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatOptionModule,
    MatInputModule,
    GmDashboardRoutingModule,
    AcademicFormModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatDividerModule,
    MatCardModule,
    MatDialogModule,
    MatIconModule,
    NgxSpinnerModule,
  ]
})
export class GmDashboardModule { }
